export default __webpack_public_path__ + "static/media/the-kingfisher.184c78a8.jpg";